site.sponsCarousel = {
	init:function() {
		site.owl.init('#sponsCarousel ul', {
			loop: false,
			dots: false,
			nav: true,
			items: 1,
			navText: ["", ""],
			responsive: {
				1500: {
					items: 6,
					slideBy: 6
				},
				1320 : {
					items: 5,
					slideBy: 5
				},
				1080 : {
					items: 4,
					slideBy: 4
				},
				880 : {
					items: 3,
					slideBy: 3
				},
				630 : {
					items: 2,
					slideBy: 2
				},
				0: {
					items: 1,
					slideBy: 1
				}
			}
		});
	}
};

site.inits.push('site.sponsCarousel.init()');
